import React, { useState } from "react";
import "./popup.css";

export default function SiteLayout({ layouts }) {
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleDownloadClick = (layout) => {
    setSelectedFile(layout);
    setPopupOpen(true);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Collect form data if needed, e.g., send to server here

    setPopupOpen(false);

    if (selectedFile) {
      const link = document.createElement("a");
      link.href = selectedFile.src;
      link.download = selectedFile.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="Home_5">
      <h1>Site Layout Marking</h1>
      <div className="site_points">
        {layouts.map((layout, index) => (
          <div className="site_card" key={index}>
            <img src={layout.src} alt={layout.name} className="blur-image" />
            <h3>{layout.name}</h3>
            <button
              onClick={() => handleDownloadClick(layout)}
              className="download-btn"
            >
              Download
            </button>
          </div>
        ))}
      </div>

      {popupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Contact Form</h2>
            <form onSubmit={handleFormSubmit}>
              <label>
                Name:
                <input type="text" name="name" required />
              </label>
              <label>
                Email:
                <input type="email" name="email" required />
              </label>
              <label>
                Message:
                <textarea name="message" required />
              </label>
              <button type="submit">Submit & Download</button>
              <button
                type="button"
                onClick={() => setPopupOpen(false)}
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
